import { Client } from '@stomp/stompjs';
import SockJS from 'sockjs-client';

const connectWebSocket = (url, onMessageReceived) => {
    const client = new Client({
        brokerURL: 'wss://' + process.env.REACT_APP_URL.replace('https://', '') + 'ws',
        webSocketFactory: () => new SockJS(process.env.REACT_APP_URL + 'ws'),
        reconnectDelay: 5000,
        onConnect: () => {
            client.subscribe(`/topic/${url}`, (message) => {
                try {
                    const parsed = JSON.parse(message.body);
                    onMessageReceived(parsed);
                } catch (e) {
                    console.warn("Mensaje no es JSON, se envía como texto plano");
                    onMessageReceived(message.body);
                }
            });
        },
        onStompError: (error) => {
            //console.error('WebSocket error', error);
        },
    });
    client.activate();
};

export default connectWebSocket;
